export const getLeadRatingText = (rating?: string): string => {
  if (!rating) return "Unknown";

  switch (rating.toLowerCase()) {
    case "hot":
      return "High Intent";
    case "interested":
      return "Low Intent";
    case "warm":
      return "Medium Intent";
    case "Rejected":
      return "Rejected";
    case "system error":
      return "System Error";
    case "in progress":
      return "In Progress";
    default:
      return rating;
  }
};
